import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { showError } from "../../../../redux/common/actions";
import { duplicateTask } from "services/models/modelDetails/modelTasks";

// Single-task duplicate, invoked from a row's own dot-menu. Distinct from the
// bulk-duplicate flow (useBulkTaskDuplicate), which acts on a selection.
const useDuplicateTask = ({ modelId, totalTaskCount, ModelCtxDispatch, updatedFieldFunc, fetchData }) => {
	const [duplicating, setDuplicating] = useState(false);
	const dispatch = useDispatch();

	const handleDuplicate = useCallback(
		async (toDuplicateTask) => {
			setDuplicating(true);
			try {
				const response = await duplicateTask(toDuplicateTask?.id);
				await fetchData("", modelId, false, "");
				ModelCtxDispatch({
					type: "TAB_COUNT",
					payload: { countTab: "taskCount", data: totalTaskCount + 1 },
				});
				updatedFieldFunc({ data: response.data });
			} catch (error) {
				dispatch(showError(error?.response?.data || "something went wrong"));
			}
			setDuplicating(false);
		},
		[ModelCtxDispatch, dispatch, fetchData, modelId, totalTaskCount, updatedFieldFunc]
	);

	return { duplicating, handleDuplicate };
};

export default useDuplicateTask;
